module.exports = __webpack_public_path__ + "img/standard-account.a436cf7.svg";